import * as types from '../../../../lib/actionTypes.es6'

export const getPolicyProcessingDcpRequest = guid => ({
  type: types.GET_POLICY_PROCESSING_DCP_REQUEST,
  payload: guid
})

export const getPolicyProcessingDcpSuccess = payload => ({
  type: types.GET_POLICY_PROCESSING_DCP_SUCCESS,
  payload
})

export const getPolicyProcessingDcpFailure = error => ({
  type: types.GET_POLICY_PROCESSING_DCP_FAILURE,
  payload: error
})

export const getPolicyProcessingCustomerQuotesRequest = payload => ({
  type: types.GET_POLICY_PROCESSING_CUSTOMER_QUOTES_REQUEST,
  payload
})

export const getPolicyProcessingCustomerQuotesSuccess = payload => ({
  type: types.GET_POLICY_PROCESSING_CUSTOMER_QUOTES_SUCCESS,
  payload
})

export const getPolicyProcessingCustomerQuotesFailure = error => ({
  type: types.GET_POLICY_PROCESSING_CUSTOMER_QUOTES_FAILURE,
  payload: error
})

export function policyActionRequest(payload) {
  return {
    type: types.POLICY_ACTION_REQUEST,
    payload
  }
}

export function policyActionSuccess(response) {
  return {
    type: types.POLICY_ACTION_SUCCESS,
    payload: response
  }
}

export function policyActionFailure(error) {
  return {
    type: types.POLICY_ACTION_FAILURE,
    payload: error
  }
}

export function resetPolicyActionSuccess(error) {
  return {
    type: types.RESET_POLICY_ACTION_SUCCESS
  }
}

export function resetPolicyActionError(error) {
  return {
    type: types.RESET_POLICY_ACTION_ERROR
  }
}

export function setPolicyToApprove(response) {
  return {
    type: types.SET_POLICY_TO_APPROVE,
    payload: response
  }
}

export function resetPolicyToApprove(response) {
  return {
    type: types.RESET_POLICY_TO_APPROVE
  }
}

export function policyRejectActionRequest(payload) {
  return {
    type: types.POLICY_REJECT_ACTION_REQUEST,
    payload
  }
}

export function policyRejectActionSuccess(response) {
  return {
    type: types.POLICY_REJECT_ACTION_SUCCESS,
    payload: response
  }
}

export function policyRejectActionFailure(error) {
  return {
    type: types.POLICY_REJECT_ACTION_FAILURE,
    payload: error
  }
}

export function makerCheckDecisionRequest(payload) {
  return {
    type: types.MAKER_CHECK_DECISION_REQUEST,
    payload
  }
}

export function makerCheckDecisionSuccess(response) {
  return {
    type: types.MAKER_CHECK_DECISION_SUCCESS,
    payload: response
  }
}

export function makerCheckDecisionFailure(error) {
  return {
    type: types.MAKER_CHECK_DECISION_FAILURE,
    payload: error
  }
}

export function resetMakerCheckDecision() {
  return {
    type: types.RESET_MAKER_CHECK_DECISION
  }
}

export function returnToPriorStageRequest(payload) {
  return { type: types.RETURN_TO_PRIOR_STAGE_REQUEST, payload }
}
export function returnToPriorStageSuccess(response) {
  return { type: types.RETURN_TO_PRIOR_STAGE_SUCCESS, payload: response }
}
export function returnToPriorStageFailure(error) {
  return { type: types.RETURN_TO_PRIOR_STAGE_FAILURE, payload: error }
}
export function resetReturnToPriorStage() {
  return { type: types.RESET_RETURN_TO_PRIOR_STAGE }
}

// The "needs changes" round trip is its own action rather than a bare
// policyActionRequest: it writes the need_action flag and, optionally, the
// note explaining it, and both the checker and the broker need to see whether
// that worked. Riding on policyActionRequest gave it only the generic
// "Policy updated successfully" dialog, so a failed write looked like nothing
// happening at all.
export function setNeedActionRequest(payload) {
  return {
    type: types.SET_NEED_ACTION_REQUEST,
    payload
  }
}

export function setNeedActionSuccess(response) {
  return {
    type: types.SET_NEED_ACTION_SUCCESS,
    payload: response
  }
}

export function setNeedActionFailure(error) {
  return {
    type: types.SET_NEED_ACTION_FAILURE,
    payload: error
  }
}

export function resetSetNeedAction() {
  return {
    type: types.RESET_SET_NEED_ACTION
  }
}

export function quotationDecisionRequest(payload) {
  return {
    type: types.QUOTATION_DECISION_REQUEST,
    payload
  }
}

export function quotationDecisionSuccess(response) {
  return {
    type: types.QUOTATION_DECISION_SUCCESS,
    payload: response
  }
}

export function quotationDecisionFailure(error) {
  return {
    type: types.QUOTATION_DECISION_FAILURE,
    payload: error
  }
}

export function resetQuotationDecision() {
  return {
    type: types.RESET_QUOTATION_DECISION
  }
}

export const cancelPolicyActionRequest = payload => ({
  type: types.CANCEL_POLICY_ACTION_REQUEST,
  payload
})

export const cancelPolicyActionSuccess = response => ({
  type: types.CANCEL_POLICY_ACTION_SUCCESS,
  payload: response
})

export const cancelPolicyActionFailure = error => ({
  type: types.CANCEL_POLICY_ACTION_FAILURE,
  payload: error
})

export function addPolicyNotesRequest(payload) {
  return {
    type: types.ADD_POLICY_NOTES_REQUEST,
    payload
  }
}

export function addPolicyNotesSuccess(response) {
  return {
    type: types.ADD_POLICY_NOTES_SUCCESS,
    payload: response
  }
}

export function addPolicyNotesFailure(error) {
  return {
    type: types.ADD_POLICY_NOTES_FAILURE,
    payload: error
  }
}

export function resetAddPolicyNotesSuccess(error) {
  return {
    type: types.RESET_ADD_POLICY_NOTES_SUCCESS
  }
}

export function resetAddPolicyNotesError(error) {
  return {
    type: types.RESET_ADD_POLICY_NOTES_ERROR
  }
}

export function deletepolicyDocumentRequest(payload) {
  return {
    type: types.DELETE_POLICY_DOCUMENT_REQUEST,
    payload
  }
}

export function deletepolicyDocumentSuccess(response) {
  return {
    type: types.DELETE_POLICY_DOCUMENT_SUCCESS,
    payload: response
  }
}

export function deletepolicyDocumentFailed(error) {
  return {
    type: types.DELETE_POLICY_DOCUMENT_FAILURE,
    payload: error
  }
}

export function setpolicyDocumentsToDelete(response) {
  return {
    type: types.SET_POLICY_DOCUMENT_TO_DELETE,
    payload: response
  }
}

export function resetHardDeletepolicyDocumentSuccess() {
  return {
    type: types.RESET_DELETE_POLICY_DOCUMENT_SUCCESS
  }
}

export function resetPolicyDocumentToDelete() {
  return {
    type: types.RESET_POLICY_DOCUMENT_TO_DELETE
  }
}
export function resetHardDeletepolicyDocumentError() {
  return {
    type: types.RESET_POLICY_DELETE_DOCUMENT_ERROR
  }
}

export const getPaymentsByPolicyGuidRequest = guid => ({
  type: types.GET_PAYMENTS_BY_POLICY_GUID_REQUEST,
  payload: guid
})

export const getPaymentsByPolicyGuidSuccess = payload => ({
  type: types.GET_PAYMENTS_BY_POLICY_GUID_SUCCESS,
  payload
})

export const getPaymentsByPolicyGuidFailure = error => ({
  type: types.GET_PAYMENTS_BY_POLICY_GUID_FAILURE,
  payload: error
})

export function initiatePaymentRequest(payload) {
  return {
    type: types.INITIATE_PAYMENT_REQUEST,
    payload
  }
}

export function initiatePaymentSuccess(payload) {
  return {
    type: types.INITIATE_PAYMENT_SUCCESS,
    payload
  }
}

export function initiatePaymentFailure(payload) {
  return {
    type: types.INITIATE_PAYMENT_FAILURE,
    payload
  }
}

export function resetInitiatePayment() {
  return {
    type: types.RESET_INITIATE_PAYMENT
  }
}

export function generatePolicyCheckoutLinkRequest(payload) {
  return {
    type: types.GENERATE_POLICY_CHECKOUT_LINK_REQUEST,
    payload
  }
}

export function generatePolicyCheckoutLinkSuccess(payload) {
  return {
    type: types.GENERATE_POLICY_CHECKOUT_LINK_SUCCESS,
    payload
  }
}

export function generatePolicyCheckoutLinkFailure(payload) {
  return {
    type: types.GENERATE_POLICY_CHECKOUT_LINK_FAILURE,
    payload
  }
}

export function resetPolicyCheckoutLink() {
  return {
    type: types.RESET_POLICY_CHECKOUT_LINK
  }
}

export const findCustomerForTransferRequest = payload => ({
  type: types.FIND_CUSTOMER_FOR_TRANSFER_REQUEST,
  payload
})

export const findCustomerForTransferSuccess = payload => ({
  type: types.FIND_CUSTOMER_FOR_TRANSFER_SUCCESS,
  payload
})

export const findCustomerForTransferFailure = error => ({
  type: types.FIND_CUSTOMER_FOR_TRANSFER_FAILURE,
  payload: error
})

export const resetFindCustomerForTransfer = () => ({
  type: types.RESET_FIND_CUSTOMER_FOR_TRANSFER
})

export const switchPolicyCustomerRequest = payload => ({
  type: types.SWITCH_POLICY_CUSTOMER_REQUEST,
  payload
})

export const switchPolicyCustomerSuccess = payload => ({
  type: types.SWITCH_POLICY_CUSTOMER_SUCCESS,
  payload
})

export const switchPolicyCustomerFailure = error => ({
  type: types.SWITCH_POLICY_CUSTOMER_FAILURE,
  payload: error
})

export const resetSwitchPolicyCustomerSuccess = () => ({
  type: types.RESET_SWITCH_POLICY_CUSTOMER_SUCCESS
})

export const resetSwitchPolicyCustomerError = () => ({
  type: types.RESET_SWITCH_POLICY_CUSTOMER_ERROR
})
